import { connect } from 'react-redux'
import filesForm from '../ui/forms/filesForm'
import { setFiles } from '../../store/actions/filesActions'

const mapStateToProps = state => ({
    filesList: state.files
})

const mapDispatchToProps = dispatch => {
    return {
        filesToState: (val) => {
            dispatch(
                setFiles(val)
            )
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(filesForm)